{
    "noesis": {
        "page_title": "Noesis",
        "page_subtitle": "Your AI agent for smarter environmental monitoring",
        "chart": {
            "unavailable": "This chart can't be displayed.",
            "download": "Download chart",
            "download_png": "Image (PNG)",
            "download_svg": "Image (SVG)",
            "download_csv": "Data (CSV)"
        },
        "buttons": {
            "new_chat": "New chat",
            "ask": "Ask Noesis"
        },
        "input": {
            "placeholder": "Ask Noesis...",
            "edit_placeholder": "Edit your message..."
        },
        "token_limit": {
            "reached": "Token limit reached. Start a new thread to continue."
        },
        "token_usage": {
            "title": "Token usage",
            "aria": "Token usage {{percent}} percent of limit"
        },
        "voice": {
            "start_recording": "Record a voice message",
            "dictate": "Dictate",
            "cancel_recording": "Cancel recording",
            "apply_recording": "Transcribe voice message",
            "transcribing": "Transcribing…",
            "mic_permission_denied": "Microphone access is blocked. Enable it in your browser settings to use voice messages.",
            "no_audio_captured": "No audio was captured. Please try again.",
            "transcription_failed": "Could not transcribe your voice message. Please try again."
        },
        "files": {
            "attach": "Attach data file (CSV, XLSX)",
            "remove": "Remove file",
            "unsupported": "\"{{name}}\" isn't supported. Attach a CSV or XLSX file.",
            "too_large": "\"{{name}}\" is larger than {{max}} MB.",
            "too_many": "You can attach up to {{max}} files.",
            "upload_failed": "Couldn't upload \"{{name}}\". Please try again.",
            "remove_failed": "Couldn't remove the file. Please try again."
        },
        "welcome": {
            "title": "Need insights? Just ask.",
            "examples": {
                "air_quality": "What was the air quality today for office devices according to Well V2 standard for indoor spaces?",
                "smoke_detection": "Detect any smoke during last 6 hours for devices from 5th floor",
                "pdf_report": "Generate a PDF report of PM2.5 levels for 1C041149, 1C083036 devices during last week with trend charts",
                "csv_export": "Export to CSV Mass Conc. Total exceeding 0.015 mg/m³ using 15 minutes average from last 24 hours",
                "device_diagnostics": "Diagnose devices with DustTrak sensors"
            }
        },
        "messages": {
            "processing": "Processing your request..."
        },
        "actions": {
            "try_again": "Try again",
            "edit_message": "Edit message",
            "good_response": "Good response",
            "bad_response": "Bad response"
        },
        "about_title": "Noesis Capabilities",
        "threads_sidebar": {
            "empty_title": "No chat threads yet",
            "empty_description": "Start a new conversation to begin",
            "delete_thread": "Delete"
        },
        "chats_panel": {
            "title": "Chats",
            "search_placeholder": "Search chats",
            "search_empty": "No chats found",
            "about_link": "About Noesis",
            "demo_link": "Request a Demo",
            "pinned_group": "Pinned",
            "recent_group": "Recent",
            "rename": "Rename",
            "pin": "Pin to top",
            "unpin": "Unpin",
            "chat_options": "Chat options",
            "processing": "Processing"
        }
    }
}